// @flow
import {
	type Theme,
	getColor,
	getSize,
	getWeight,
} from "views/resources/theme";
import styled, { type StyledComponent } from "styled-components";
import type { Node } from "react";

type WrapperProps = {|
	color: string,
	size: number,
	inline: boolean,
	children: Node[],
|};

export const Wrapper: StyledComponent<WrapperProps, Theme, *> = styled.div`
	color: ${(props) => props.color};
	font-size: ${(props) => props.size}rem;
	display: flex;
	align-items: center;
	flex-direction: ${(props) => (props.inline ? "row" : "column")};
	justify-content: space-between;
	span {
		margin: 0px 4px;
	}
`;

export const Info: StyledComponent<*, Theme, *> = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	span {
		color: ${getColor("primary")};
		font-size: 1.8rem;
		font-weight: ${getWeight("semibold")};
		margin: 0 ${getSize("xs")};
	}
`;

export const InfoBox: StyledComponent<*, Theme, *> = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0;
	p {
		font-size: ${getSize("sm")};
		font-size: 12px;
		font-weight: 300;
		letter-spacing: 0px;
		text-align: center;
		margin: 0;
		max-width: 120px;
	}

	@media screen and (min-width: 768px) {
		& {
			flex-direction: row;
			background-color: #f6f6f6;
			padding: 10px;
			border-radius: 10px;
		}
		p {
			font-weight: 600;
		}
	}
`;
